import React,{useState} from 'react'
import './payments.css'
import { toast } from 'react-toastify' 
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'

const Payments = () => {

  const [formdata, setFormdata] = useState({
    'name' : '',
    'email' : '',
    'amount' : '',
    'productId' : '',
    'productName' : ''
  });
  const [error,setError] = useState({
    'name' : false,
    'email' : false,
    'amount' : false,
    'productId' : false,
  })
  const [emailError,setEmailError] = useState(false);
  const [loading,setLoading] = useState(false);

  const handleChange = (e) => {
    let data = {...formdata}
    if(e.target.name === "productId"){
      let product = e.target.value;
      if(product === "prod_Pz3YoNsHS9i5Re"){
        data.productId = "prod_Pz3YoNsHS9i5Re"
        data.productName = "IELTS"
      }else if(product === "prod_PzJeTYbuAEeKFp"){
        data.productId = "prod_PzJeTYbuAEeKFp"
        data.productName = "CAMBRI"
      }else if(product === "prod_PzJeBp2payJp9b"){
        data.productId = "prod_PzJeBp2payJp9b"
        data.productName = "TUTOR"
      }else if(product === "prod_TCz1DsKjw1LU8E"){
        data.productId = "prod_TCz1DsKjw1LU8E"
        data.productName = "FRESHERS_TODAY"
      }else if(product === "prod_PzJflSNqnYUtzY"){
        data.productId = "prod_PzJflSNqnYUtzY"
        data.productName = "OTHERS"
      }
    }else if(e.target.name === "email"){
      if(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(e.target.value)){
        setEmailError(false);
      }else{
        setEmailError(true);
      }
      data.email = e.target.value;
    }else if(e.target.name === "amount"){
      if(/^[0-9]+$/.test(e.target.value) || e.target.value === "" ){
        data.amount = e.target.value;
      }
    }else{
      data[e.target.name] = e.target.value;
    }
    setFormdata(data);
  }

  const handleSubmit = async (e) => {
    let errorData = {...error}
    if(formdata.name === ""){
      errorData.name = true;
    }else{
      errorData.name = false;
    }
    if(formdata.email === ""){
      errorData.email = true;
    }else{
      errorData.email = false;
    } 
    if(formdata.amount === ""){
      errorData.amount = true;
    }else{
      errorData.amount = false;
    } 
    if(formdata.productId === ""){
      errorData.productId = true;
    }else{
      errorData.productId = false;
    }
    setError(errorData)
    if( !errorData.name && !errorData.email && !errorData.amount && !errorData.productId && !emailError){
        setLoading(true);
        try{
          let url = 'https://api.ei.fallnspring.com/api/payments/stripe/createpayment'
          let response = await axios.post(url,formdata) // need to work on this API URL
          if(response.status === 200){
            const message = response?.data?.message
            setLoading(false);
            toast.success(message ?? "Email sent successfully")
            setFormdata({
              'name' : '',
              'email' : '',
              'amount' : '',
              'productId' : '',
              'productName' : ''
            })
          }else{
            setLoading(false);
            const message = response?.data?.message
            toast.error(message ?? "Email delivery failed")
            setFormdata({
              'name' : '',
              'email' : '',
              'amount' : '',
              'productId' : '',
              'productName' : ''
            })
          }
        }catch(error){
          setLoading(false);
          const message = error?.response?.data?.message
          toast.error(message ?? "Email delivery failed")
          setFormdata({
            'name' : '',
            'email' : '',
            'amount' : '',
            'productId' : '',
            'productName' : ''
          })
          console.error(error)
        }
    }
  }

return (
  <div className="container">
    {
      loading 
      ? 
      <div className='loader-class'>
        <div class="loader"></div>
      </div>
       :
       <>
        <h1 className='heading'>Freshers Today Payments</h1>
        <div className='form'>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formdata.name}
            onChange={handleChange}
          />
          {error.name && <p className='error'>Please enter the name</p>}
          <input
            type="email"
            name='email'
            placeholder="Email"
            value={formdata.email}
            onChange={handleChange}
          />
          {error.email && <p className='error'>Please enter the email</p>}
          {emailError && <p className='error'>Please enter valid email</p>}
          <input
            type="text"
            name="amount"
            placeholder="Amount"
            value={formdata.amount}
            onChange={handleChange}
          />
          {error.amount && <p className='error'>Please enter the amount</p>}
          <select name='productId' value={formdata.productId} onChange={handleChange}>
            <option value="">-- Select Product --</option>
            <option value="prod_Pz3YoNsHS9i5Re">IELTS</option>
            <option value="prod_PzJeTYbuAEeKFp">Cambri</option>
            <option value="prod_PzJeBp2payJp9b">Tutor</option>
            <option value="prod_TCz1DsKjw1LU8E">Freshers Today</option>
            <option value="prod_PzJflSNqnYUtzY">Others</option>
          </select>
          {error.productId && <p className='error'>Please select the product</p>}
          <button type="submit" onClick={handleSubmit}>Submit</button>
        </div>
      </>
    }

  </div>

);
}

export default Payments